// extracted by mini-css-extract-plugin
export default {"modal_content":"BrowserPermission_modal_content__E2XHq"};